import { ModalButton } from './ModalButton';
import { ModalButtonRoot } from './ModalButtonRoot';
import { ModalRoot } from './ModalRoot';

export const Modal = {
  Root: ModalRoot,
  Button: ModalButton,
  ButtonRoot: ModalButtonRoot,
};
